// extracted by mini-css-extract-plugin
var _1 = "HoverText__b--dMSvf";
var _2 = "HoverText__bl--NB344";
var _3 = "HoverText__br--vx_k6";
var _4 = "HoverText__container--pnmK2 CoreGeneral__roboto--UlmjE";
var _5 = "HoverText__l--O8QJ9";
var _6 = "HoverText__large--c94OM HoverText__container--pnmK2 CoreGeneral__roboto--UlmjE";
var _7 = "HoverText__main--JSzNb";
var _8 = "HoverText__medium--Ptlyl HoverText__container--pnmK2 CoreGeneral__roboto--UlmjE";
var _9 = "HoverText__noWrap--aYxjA";
var _a = "HoverText__r--MaL3A";
var _b = "HoverText__small--ekLSM HoverText__container--pnmK2 CoreGeneral__roboto--UlmjE";
var _c = "HoverText__t--ZQD7k";
var _d = "HoverText__tl--bYnpy";
var _e = "HoverText__tr--bm6d1";
export { _1 as "b", _2 as "bl", _3 as "br", _4 as "container", _5 as "l", _6 as "large", _7 as "main", _8 as "medium", _9 as "noWrap", _a as "r", _b as "small", _c as "t", _d as "tl", _e as "tr" }
